import PropTypes from "prop-types";
import { useState, useEffect, useRef } from "react";
import LegalBar from "../LegalBar";
import InternationalSites from "./InternationalSites";
import styles from "./Footer.css";
import {
  SMALL_VIEWPORT,
  MEDIUM_VIEWPORT,
  LARGE_VIEWPORT
} from "../../state/modules/layout";
import AppDownload from "../AppDownload";
import MainContent from "./MainContent";
import NewsletterSignupFormBase from "./NewsletterSignupForm";
import withViewport from "../Viewport/withViewport";
import { useSelector } from "react-redux";
import { isLoggedIn } from "../../state/modules/user";
import clientConfig from "../../clientConfig";

const NewsletterSignupForm = withViewport(NewsletterSignupFormBase);

const Footer = ({ isAccordion, ...rest }) => {
  const authenticated = useSelector(state => isLoggedIn(state));
  const [isBrazeInitialised, setIsBrazeInitialised] = useState(false);
  const footerRef = useRef(null);
  const appDownloadBannerViewports = [MEDIUM_VIEWPORT, LARGE_VIEWPORT];

  useEffect(() => {
    const el = footerRef.current;

    let intervalId;
    let timeoutId;

    const startBrazeCheck = () => {
      if (clientConfig.isLocal()) {
        setIsBrazeInitialised(true);
        return;
      }
      if (window.braze) {
        setIsBrazeInitialised(true);
        return;
      }
      intervalId = setInterval(() => {
        if (window.braze) {
          setIsBrazeInitialised(true);
          clearInterval(intervalId);
          clearTimeout(timeoutId);
        }
      }, 100);
      timeoutId = setTimeout(() => {
        clearInterval(intervalId);
      }, 500);
    };

    if (!el || !window.IntersectionObserver) {
      startBrazeCheck();
      return () => {
        clearInterval(intervalId);
        clearTimeout(timeoutId);
      };
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting) return;
        observer.disconnect();
        startBrazeCheck();
      },
      { rootMargin: "200px" }
    );

    observer.observe(el);
    return () => {
      observer.disconnect();
      clearInterval(intervalId);
      clearTimeout(timeoutId);
    };
  }, []);

  return (
    <footer ref={footerRef} className={styles.container} data-testid="footer">
      {isAccordion ? (
        <MainContent isAccordion={true} {...rest} viewable={[SMALL_VIEWPORT]} />
      ) : (
        <>
          <AppDownload
            variant="banner"
            viewable={appDownloadBannerViewports}
            ctaRef={"global footer|appDownload banner|our apps"}
          />
          <AppDownload
            viewable={[SMALL_VIEWPORT]}
            isLoggedIn={authenticated}
            isBrazeInitialised={isBrazeInitialised}
            ctaRef={"global footer|appDownload component|our apps"}
          />
          <MainContent
            isAccordion={false}
            {...rest}
            viewable={appDownloadBannerViewports}
            isBrazeInitialised={isBrazeInitialised}
          />
          {!authenticated && isBrazeInitialised && (
            <NewsletterSignupForm viewable={[SMALL_VIEWPORT]} />
          )}
          <InternationalSites viewable={[SMALL_VIEWPORT]} />
          <LegalBar />
        </>
      )}
    </footer>
  );
};

Footer.propTypes = {
  isAccordion: PropTypes.bool
};

export default Footer;
